import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { UserStatus } from 'user/model/user-status';

import { Direction } from '../../../../common/api.adpater';
import { ApiPageableOutput } from '../../../../common/model/api-pageable.output';
import { ApiQuery } from '../../../../common/model/api.query';
import { users } from '../model/user.fragments';
import { UserOutput } from '../model/user.output';
import { UserSort } from '../model/user.sort';

export interface SearchCoacheesIncludingPartnersInput {
	readonly chunkSize: number;
	readonly emailAddress?: string;
	readonly firstName?: string;
	readonly lastName?: string;
	readonly name?: string;
	readonly offset: number;
	readonly organizationId?: string;
	readonly sortDirection: Direction;
	readonly sortProperty: UserSort;
	readonly statuses?: UserStatus[];
}

export interface SearchCoacheesIncludingPartnersParams {
	query: SearchCoacheesIncludingPartnersInput;
}

@Injectable({ providedIn: 'root' })
export class SearchCoacheesIncludingPartnersApiQuery extends ApiQuery<
	ApiPageableOutput<UserOutput>,
	SearchCoacheesIncludingPartnersParams
> {
	client = 'iam';
	document = gql`
		query SearchCoacheesIncludingPartners(
			$query: SearchCoacheesIncludingPartnersInput!
		) {
			searchCoacheesIncludingPartners(input: $query) {
				elements {
					...Users
				}
				totalElements
			}
		}
		${users}
	`;
	method = 'searchCoacheesIncludingPartners';
}
